"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _reactHabitat = _interopRequireDefault(require("@eon-funke/react-habitat"));
var _reactHabitatRedux = require("@eon-funke/react-habitat-redux");
var _configureStore = _interopRequireDefault(require("./store/configureStore"));
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = (0, _getPrototypeOf2.default)(derived);
  return (0, _possibleConstructorReturn2.default)(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], (0, _getPrototypeOf2.default)(_this).constructor) : derived.apply(_this, args));
}
var HabitatLauncher = /*#__PURE__*/function (_ReactHabitat$Bootstr) {
  function HabitatLauncher(stuff) {
    var _this2;
    (0, _classCallCheck2.default)(this, HabitatLauncher);
    _this2 = _callSuper(this, HabitatLauncher, [stuff]);
    _this2.numberOfApps = 0;
    _this2.appsTriggered = 0;
    return _this2;
  }
  (0, _inherits2.default)(HabitatLauncher, _ReactHabitat$Bootstr);
  return (0, _createClass2.default)(HabitatLauncher, [{
    key: "waitToSetContainer",
    value: function waitToSetContainer(containerBuilder) {
      var _this3 = this;
      var readyStateCheckInterval = setInterval(function () {
        if (_this3.numberOfApps !== 0 && _this3.numberOfApps === _this3.appsTriggered) {
          clearInterval(readyStateCheckInterval);
          _this3.setContainer(containerBuilder.build());
        }
      }, 10);
    }
  }, {
    key: "startRoutes",
    value: function startRoutes(routes, containerBuilder) {
      var _this4 = this;
      this.numberOfApps = routes.length;
      routes.forEach(function (route) {
        route.load(containerBuilder, function () {
          _this4.appsTriggered += 1;
        });
      });
      this.waitToSetContainer(containerBuilder);
    }
  }, {
    key: "startRootApp",
    value: function startRootApp(routes, miniAppNames, axiosClients) {
      var store = (0, _configureStore.default)({}, axiosClients);

      // Create a new container builder
      var containerBuilder = new _reactHabitat.default.ContainerBuilder();

      // Set a new 'Redux' factory for the store
      containerBuilder.factory = new _reactHabitatRedux.ReduxDomFactory(store);
      this.startRoutes(routes, containerBuilder);
    }
  }]);
}(_reactHabitat.default.Bootstrapper);
var _default = exports.default = HabitatLauncher;